import { createApi } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "../../common/utils";
import { HOSTNAME } from "../../constant/host";

/* ===============================
  MCP API Keys API の定義
=============================== */

export const mcpApiKeysApi = createApi({
  reducerPath: "mcpApiKeysApi",
  // 認証・CSRF・act-as ヘッダー付きの共通 baseQuery（デモガード込み）
  baseQuery: createAuthBaseQuery(HOSTNAME),
  tagTypes: ["MCPApiKey"],
  endpoints: (builder) => ({
    // APIキー一覧取得
    getMCPApiKeys: builder.query({
      query: () => ({
        url: "/api/me/mcp/api-keys",
        method: "GET",
      }),
      providesTags: ["MCPApiKey"],
    }),

    // 個別APIキー取得
    getMCPApiKeyById: builder.query({
      query: (id) => ({
        url: `/api/me/mcp/api-keys/${id}`,
        method: "GET",
      }),
    }),

    // APIキー作成
    createMCPApiKey: builder.mutation({
      query: (apiKeyData) => ({
        url: "/api/me/mcp/api-keys",
        method: "POST",
        body: apiKeyData,
      }),
      invalidatesTags: ["MCPApiKey"],
    }),

    // APIキー更新
    updateMCPApiKey: builder.mutation({
      query: ({ id, ...apiKeyData }) => ({
        url: `/api/me/mcp/api-keys/${id}`,
        method: "PATCH",
        body: apiKeyData,
      }),
      invalidatesTags: ["MCPApiKey"],
    }),

    // APIキー削除
    deleteMCPApiKey: builder.mutation({
      query: (id) => ({
        url: `/api/me/mcp/api-keys/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MCPApiKey"],
    }),
  }),
});

// RTK Query で生成されたフックをエクスポート
export const {
  useGetMCPApiKeysQuery,
  useGetMCPApiKeyByIdQuery,
  useCreateMCPApiKeyMutation,
  useUpdateMCPApiKeyMutation,
  useDeleteMCPApiKeyMutation,
} = mcpApiKeysApi;
